import { Component, OnInit } from '@angular/core';
import { PointDetail, PointType } from 'src/app/models/point';
import { PointService } from 'src/app/services/point.service';

@Component({
  selector: 'app-history-point',
  templateUrl: './history-point.component.html',
  styleUrls: ['./history-point.component.css']
})
export class HistoryPointComponent implements OnInit {

  public points: PointDetail[] = [];
  public offset = 0;
  public limit = 10;
  public isLoading = false;
  public canShowMore = false;

  constructor(private pointService: PointService) { }

  public get pointType() {
    return PointType;
  }

  ngOnInit() {
    this.getPoint();
  }

  getPoint() {
    this.isLoading = true;
    this.pointService.getPointDetail(this.offset, this.limit,
      (data) => {
        this.points = data;
        if (data.length >= 10) {
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }
      },
      (err) => {
        console.log(err);
      });
    this.isLoading = false;
  }

  showMore() {
    this.isLoading = true;
    this.canShowMore = false;
    this.offset += this.limit;

    this.pointService.getPointDetail(this.offset, this.limit,
      (data) => {
        data.forEach(item => {
          this.points.push(item);
        });

        if (data.length >= 10) {
          this.canShowMore = true;
        }

        this.isLoading = false;
      },
      (err) => {
        console.log(err);
      });
  }
}
